import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PaymentPlansTable from "../../components/PaymentPlans/PaymentPlansTable";





const PaymentPlanPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Payment Plans" />

       {/* Projects Table */}
        <PaymentPlansTable />

      </MasterLayout>
    </>
  );
};

export default PaymentPlanPage;
